import queryString from 'query-string';
import _ from 'lodash';

/*
  Registration State Machine:
  Manage actions, page location and final redirect while in the Login module

  Available login module actions (these map to content stack forms under 'Login')
  action                     purpose
  ------------------------   ------------------------------------------
  email_not_verified         show "email has not been verified" dialog
  email_verification_error   show error in email verification (what you see after clicking on expired email link)
  email_verified             show confirmation that email has been verified (what you see after clicking on email link)
  login                      show login form
  logout                     show currently logged in user and allow for logout
  password_is_reset          show confirmation that password has been reset
  password_reset_email_sent  show confirmation that password reset email has been sent
  register                   show new user registration form
  reset_password             show reset password form
  verification_email_sent    show confirmation that verification email has been sent

  Configured react routes:
  /login
  /logout
  /register
  /reset-password
  /verify-email
  /verify-email-error
*/

export const getRegistrationActionFromPath = (login_status, location) => {
  // generates the correct action name based upon path and login status
  var action = null;
  // 1. map action from current location
  switch (location.pathname) {
    case '/logout':
      action = 'logout';
      break;
    case '/register':
      action = 'register';
      break;
    case '/send-password-reset':
      action = 'send_password_reset';
      break;
    case '/reset-password':
      action = 'reset_password';
      break;
    case '/verify-email':
      action = 'email_verified';
      break;
    case '/verify-email-error':
      action = 'email_verification_error';
      break;
    default:
      action = 'login';
      break;
  }
  // 2. reset action based upon login status
  switch (login_status) {
    case 'email_not_verified':
      action = _.includes(['login', 'register'], action)
        ? 'email_not_verified'
        : action;
      break;
    case 'logged_in':
      action = _.includes(['login', 'register'], action) ? 'logout' : action;
      break;
    case 'logged_out':
      action = _.includes(['logout'], action) ? 'login' : action;
      break;
    default:
      break;
  }
  console.log(
    `Setting action to ${action} with login_status ${login_status} and location ${location.pathname}`
  );
  return action;
};

export const getNewLocationFromAction = (action, location) => {
  // set what the current path should be based upon action
  // we return null if no change is required
  var newPath = null;
  switch (action) {
    case 'logout':
      newPath = '/logout';
      break;
    case 'register':
      newPath = '/register';
      break;
    case 'reset_password':
      newPath = '/reset-password';
      break;
    case 'send_password_reset':
      newPath = '/send-password-reset';
      break;
    case 'email_verified':
      newPath = '/verify-email';
      break;
    case 'email_verification_error':
      newPath = '/verify-email-error';
      break;
    default:
      newPath = '/login';
      break;
  }
  if (location.pathname !== newPath) {
    return { pathname: newPath, search: location.search };
  } else {
    return null;
  }
};

export const getFinalRedirectLocation = (
  login_status,
  action,
  submit_status,
  location
) => {
  // generate a final redirect location if applicable
  var newPath = null;
  const queryValues = queryString.parse(location.search);
  if (queryValues.next) {
    newPath = queryValues.next;
  } else {
    newPath = '/cart';
  }
  if (
    (login_status === 'logged_in' && submit_status === 'success') ||
    (login_status === 'logged_in' &&
      queryValues.next &&
      !_.includes(['reset_password', 'password_is_reset'], action))
  ) {
    return { pathname: newPath };
  } else {
    return null;
  }
};
